import { render } from "./ChurchLifeRequestCard.vue?vue&type=template&id=06db0d9c&scoped=true"
import script from "./ChurchLifeRequestCard.vue?vue&type=script&lang=js"
export * from "./ChurchLifeRequestCard.vue?vue&type=script&lang=js"

import "./ChurchLifeRequestCard.vue?vue&type=style&index=0&id=06db0d9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06db0d9c"]])

export default __exports__